import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

const vuetify = new Vuetify({
	theme: {
		themes: {
			light: {
				primary: '#FBAF20',
				'primary-light': '#FBF4DA',
				secondary: '#FBF4DA',
				accent: colors.shades.black,
				error: colors.red.accent3,
				'text-color': '#000',
				'alert-color': '#e94747',
				'edit-color': '#dd8b1b',
				'green-color': '#3AB16E',
				'baby-blue': '#CBEFEF',
				'baby-blue-dark': '#b4dede',
				blue: '#5ACADE',
				// grey: '#F6F6F6',
				'light-pink': '#FFAAAA',
				'red-dark': '#c70d0d',
				'success-light': '#3AB16E',
				'dark-blue': '#157283',
				'green-light': '#eefff5',
				'red-light': '#ffe8e8',
				'page-color': '#fff',
				'my-grey': '#F6F6F6',
				'chip-accepted': '#ebf8f1',
				'chip-rejected': '#ffe9e9'
			},
			dark: {
				primary: '#36454f',
				'primary-light': '#434242',
				'text-color': '#fff',
				'page-color': '#333',
				'alert-color': '#e94747',
				'edit-color': '#dd8b1b',
				'green-color': '#3AB16E',
				'dark-blue': '#157283',
				'success-light': '#3AB16E',
				// grey: '#F6F6F6',
				'light-pink': '#FFAAAA',
				'red-dark': '#c70d0d',
			
				'green-light': '#2f3632',
				'red-light': '#ffe8e8',
				'my-grey': '#535353',
				'chip-accepted': '#ebf8f1',
				'chip-rejected': '#ffe9e9'
			}
		}
	}
})

export function getThemeColor (colorName) {
	return vuetify.framework.theme.themes[vuetify.framework.theme.dark ? 'dark' : 'light'][colorName]
}

export default vuetify
